import { MouseEventHandler, useMemo } from 'react';
import { SendEvmTransactionButton, SendEvmTransactionButtonProps } from '@coinbase/cdp-react';

type Props = {
  destinationAddress?: `0x${string}`;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  onError?: SendEvmTransactionButtonProps['onError'];
  onSuccess?: SendEvmTransactionButtonProps['onSuccess'];
  sourceAddress?: `0x${string}`;
};

function SendEvmEoaTransaction({
  destinationAddress,
  onClick,
  onError,
  onSuccess,
  sourceAddress,
}: Props) {
  const transaction = useMemo<SendEvmTransactionButtonProps['transaction']>(() => {
    return {
      to: destinationAddress, // Send to yourself for testing
      value: 1000000000000n, // 0.000001 ETH in wei
      gas: 21000n,
      chainId: 84532, // Base Sepolia
      type: 'eip1559',
    };
  }, [destinationAddress]);

  if (!destinationAddress || !sourceAddress) {
    return null;
  }

  return (
    <SendEvmTransactionButton
      account={sourceAddress}
      network="base-sepolia"
      transaction={transaction}
      onClick={onClick}
      onError={onError}
      onSuccess={onSuccess}
    >
      Send transaction
    </SendEvmTransactionButton>
  );
}

export { SendEvmEoaTransaction };
